import styled from 'styled-components';

export const Content = styled.div<{ $single?: boolean }>`
    display: grid;
    grid-template-columns: ${({ $single }) => ($single ? '1fr' : '50% 50%')};
    margin: 10px;
    margin-top: 40px;
    margin-bottom: 40px;

    /* After the margin shorthand, never before it — 'margin: 10px' would otherwise reset the
       auto margins that do the centring, which is exactly the bug this replaced. */
    ${({ $single }) => ($single ? 'max-width: 760px; margin-left: auto; margin-right: auto;' : '')}

    @media (max-width: 700px) {
        grid-template-columns: unset;
        grid-template-rows: auto auto;
        margin-top: 0px;
    }
`;

export const TextContainer = styled.div`
    text-align: center;
`;

export const Title = styled.h1`
    font-size: 70px;
    color: var(--text-title);

    @media (max-width: 700px) {
        padding-left: 10px;
        padding-right: 10px;
    }
`;

export const SubTitle = styled.h2`
    font-size: 30px;
    margin-left: 30px;
    margin-right: 30px;
`;

export const Description = styled.div`
    margin: 30px;
    color: rgba(255, 255, 255, 0.85);
`;

export const StoreBadge = styled.img`
    height: 45px;
    margin: 10px;
`;

export const CarouselContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 20px;

    @media (max-width: 700px) {
        margin-top: 20px;
    }
`;

/* The film sits under the fold, on its own, because it is a minute and a quarter long and
   nobody should be made to scroll past a playing phone to reach the App Store badge. */
export const FilmSection = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    padding: 0 10px 60px;
`;

export const FilmTitle = styled.h2`
    font-size: 30px;
    margin: 0;
    text-align: center;
`;

export const FilmCaption = styled.p`
    margin: 0;
    max-width: 460px;
    text-align: center;
    color: rgba(255, 255, 255, 0.7);
`;

export const FilmVideo = styled.video`
    width: 100%;
    max-width: 320px;
    height: auto;
    display: block;
    border-radius: var(--border-radius);
    background: #000;

    /* The web encode's own frame. Without it a video that has not loaded yet is the browser's default
       300x150 box, and the page jumps by five hundred pixels the moment the poster arrives —
       which, with preload="none", is exactly the case on every first visit. */
    aspect-ratio: 720 / 1560;
`;
